import React from 'react';
import { Link } from 'react-router-dom';
import { FaHome, FaChevronRight, FaArrowRight } from 'react-icons/fa';
import Navigation from '../components/Navigation';
import TopBar from '../components/TopBar';
import Footer from '../components/Footer';

const SitemapPage = () => {
    const siteStructure = [
        {
            category: 'Main',
            links: [
                { name: 'Home', path: '/' },
                { name: 'About Us', path: '/about' },
                { name: 'Contact Us', path: '/contact' }
            ]
        },
        {
            category: 'Services',
            links: [
                { name: 'IT Services Overview', path: '/services' },
                { name: 'Data Center Solutions', path: '/data-center' },
                { name: 'IT Support (24/7)', path: '/services/it-support' },
                { name: 'IT Deployment', path: '/services/it-deployment' },
                { name: 'Network Infrastructure', path: '/services/infrastructure' },
                { name: 'Network Cabling', path: '/services/network-cabling' },
                { name: 'Telecom Solutions', path: '/services/telecom' },
                { name: 'Telephony Systems', path: '/services/telephony' },
                { name: 'IoT Solutions', path: '/services/iot' },
                { name: 'Security Systems', path: '/services/security' },
                { name: 'Access Control', path: '/services/access-control' },
                { name: 'National Rollouts', path: '/services/national-rollouts' },
                { name: 'Network Refresh', path: '/services/network-refresh' },
                { name: 'WAP Deployment', path: '/services/wap-deployment' },
                { name: 'Hardware Deployment', path: '/services/hardware-deployment' },
                { name: 'Site Surveys', path: '/services/site-surveys' },
                { name: 'Break & Fix', path: '/services/break-fix' },
                { name: 'Preventive Maintenance', path: '/services/preventive-maintenance' }
            ]
        },
        {
            category: 'Legal',
            links: [
                { name: 'Privacy Policy', path: '/privacy-policy' },
                { name: 'Terms of Service', path: '/terms-of-service' }
            ]
        }
    ];

    return (
        <div className="font-sans">
            <TopBar />
            <Navigation />

            {/* Hero Section */}
            <section className="relative bg-gradient-to-br from-gray-900 via-blue-900 to-cyan-900 py-24 overflow-hidden">
                <div className="absolute inset-0 opacity-10">
                    <div className="absolute inset-0" style={{
                        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
                    }}></div>
                </div>

                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                    <nav className="flex items-center gap-2 text-sm text-gray-300 mb-8">
                        <Link to="/" className="flex items-center gap-1 hover:text-white transition-colors">
                            <FaHome size={14} />
                            <span>Home</span>
                        </Link>
                        <FaChevronRight size={10} className="text-gray-500" />
                        <span className="text-cyan-400">Sitemap</span>
                    </nav>

                    <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
                        Site <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-400">Map</span>
                    </h1>
                    <p className="text-xl text-gray-300 max-w-3xl">
                        Overview of all pages content on our website
                    </p>
                </div>
            </section>

            {/* Sitemap Content */}
            <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gray-50">
                <div className="max-w-7xl mx-auto">
                    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {siteStructure.map((section, index) => (
                            <div key={index} className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-md transition-shadow duration-300 border border-gray-100">
                                <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                                    <div className="h-8 w-1 bg-gradient-to-b from-blue-500 to-cyan-500 rounded-full"></div>
                                    {section.category}
                                </h2>
                                <ul className="space-y-4">
                                    {section.links.map((link, linkIndex) => (
                                        <li key={linkIndex}>
                                            <Link
                                                to={link.path}
                                                className="flex items-center gap-2 text-gray-600 hover:text-cyan-600 transition-colors group"
                                            >
                                                <FaArrowRight size={12} className="text-gray-300 group-hover:text-cyan-500 transition-colors" />
                                                {link.name}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
};

export default SitemapPage;
